import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { UserService, ProductService, environment, SupportService, BaseComponent, LanguageService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { filter, takeUntil } from "rxjs/operators";
import moment from "moment";
import { Router, ActivatedRoute } from "@angular/router";
import { ProductListItem } from "@mypxplat/xplat/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "myp-new-product-added",
  templateUrl: "new-product-added.component.html",
  standalone: false,
})
export class NewProductAddedComponent extends BaseComponent implements OnInit {
  public shouldShow: boolean = false;
  public product: ProductListItem;

  public description: any;

  constructor(
    userService: UserService,
    public productService: ProductService,
    public supportService: SupportService,
    public appService: AppService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public languageService: LanguageService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.productService.products$
      .pipe(
        filter((products) => !!products),
        takeUntil(this.destroy$)
      )
      .subscribe((result) => {
        if (
          this.productService.productsByReleaseDate.length &&
          this.productService.productsByReleaseDate[0].releaseDate &&
          moment(this.productService.productsByReleaseDate[0].releaseDate) > moment().subtract(2, "weeks")
        ) {
          this.shouldShow = true;
          this.product = this.productService.productsByReleaseDate[0];
          this.productService.get(`metadata/${this.product.stringId}`).subscribe((result: any) => {
            console.log(result);
            if (result.shortDescriptions && result.shortDescriptions[this.languageService.selectedLanguage?.code]) {
              this.description = result.shortDescriptions[this.languageService.selectedLanguage?.code];
            } else if (result.descriptions && result.descriptions[this.languageService.selectedLanguage?.code]) {
              this.description = result.descriptions[this.languageService.selectedLanguage?.code];
            } else {
              this.description = this.product.description;
            }
          });
        }
      });
  }

  viewProduct() {
    this.router.navigate(["products/detail/", this.product.id]);
  }
}
